var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import UserContext from './UserContext';
import LoggedOut from './pages/LoggedOut';
import ErrorPage from './pages/ErrorPage';
import { Backdrop, CircularProgress } from '@mui/material';
import { getCurrentUser } from './rest/BackendApi';
import ManagePanel from './pages/ManagePanel';
import XeroSso from './XeroSso';
import AppConfig from './AppConfig';
import UserSettingsPage from './pages/UserSettingsPage';
import SubscriptionConfirmation from './pages/SubscriptionConfirmation';
import Subscription from './pages/Subscription';
import SideNav from './sidenav';
import './App.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import minMax from 'dayjs/plugin/minMax';
import OrganisationPage from './pages/OrganisationPage';
import SupportPage from './pages/SupportPage';
import FirmPage from './pages/FirmPage';
import Header from './Header';
import EmailsPage from './pages/EmailsPage';
import XpmPage from './pages/XpmPage';
import MessageContext from './MessageContext';
import MessagePanel from './components/MessagePanel';
export const Application = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [message, setMessage] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    dayjs.extend(relativeTime);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(minMax);
    dayjs.tz.setDefault('GMT');
    useEffect(() => {
        //Empty message when navigating away
        setMessage({});
    }, [location]);
    const loadAndSetCurrentUser = (ignoreErrors) => __awaiter(void 0, void 0, void 0, function* () {
        const currentUser = yield getCurrentUser(ignoreErrors);
        if (currentUser) {
            setCurrentUser(currentUser);
            return currentUser;
        }
        return null;
    });
    const userContext = { user: currentUser, refreshUser: loadAndSetCurrentUser };
    const messageContext = { message, setMessage };
    useEffect(() => {
        const loadCurrentUserAndRedirectIfNeeded = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setPageLoading(true);
                const user = yield loadAndSetCurrentUser(false);
                setPageLoading(false);
                if (user) {
                    if (!user.hasActiveSubscription) {
                        navigate('/subscription');
                    }
                }
                else {
                    navigate('/login');
                }
                // todo handle no current user if possible?
            }
            catch (error) {
                console.error('Error while fetching current user', error);
                window.location.href = `/error?status=${error.status}&message=${error.message}`;
            }
        });
        if (currentUser == null) {
            if (window.location.pathname === '/subscription-confirmation' ||
                window.location.pathname === '/logged-out' ||
                window.location.pathname === '/login' ||
                window.location.pathname === '/signup' ||
                window.location.pathname === '/error' ||
                window.location.pathname === '/support') {
                loadAndSetCurrentUser(true);
            }
            else {
                loadCurrentUserAndRedirectIfNeeded();
            }
        }
    }, []);
    return (_jsx("div", { className: "App", children: _jsx(MessageContext.Provider, { value: messageContext, children: _jsxs(UserContext.Provider, { value: userContext, children: [_jsx(SideNav, {}), _jsxs("main", { children: [_jsx(Header, {}), _jsx(MessagePanel, { setErrorMessage: () => setMessage({}), errorMessage: message.type == 'error' ? message.content : null, setSuccessMessage: () => setMessage({}), successMessage: message.type == 'success' ? message.content : null }), _jsx(Backdrop, { sx: { color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }, open: pageLoading, children: _jsx(CircularProgress, { color: "inherit" }) }), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "/dashboard" }) }), _jsx(Route, { path: "/dashboard", element: currentUser != null ? _jsx(DashboardPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/organisations", element: currentUser != null ? _jsx(OrganisationPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/user-settings", element: currentUser != null ? _jsx(UserSettingsPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/emails", element: currentUser != null ? _jsx(EmailsPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/xpm", element: currentUser != null ? _jsx(XpmPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/firm", element: currentUser != null ? _jsx(FirmPage, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/manage", element: currentUser != null && (currentUser.isAdmin || AppConfig.isLocal) ? _jsx(ManagePanel, {}) : _jsx(_Fragment, {}) }), _jsx(Route, { path: "/subscription", element: _jsx(Subscription, {}) }), _jsx(Route, { path: "/subscription-confirmation", element: _jsx(SubscriptionConfirmation, {}) }), _jsx(Route, { path: "/logged-out", element: _jsx(LoggedOut, {}) }), _jsx(Route, { path: "/login", element: _jsx(XeroSso, { mode: "login" }) }), _jsx(Route, { path: "/signup", element: _jsx(XeroSso, { mode: "sign-up" }) }), _jsx(Route, { path: "/support", element: _jsx(SupportPage, {}) }), _jsx(Route, { path: "/error", element: _jsx(ErrorPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] })] }) }) }));
};
export default Application;
